/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import {
  ExtraFieldDetails,
  PerformanceFormDetailExtraFieldDto,
  PerformanceFormDetailExtraFieldTranslatedDto,
  PerformanceFormDetailExtraFieldViewModel,
  YearParameter,
} from './models';
import { LinqService, QueryOptions } from 'linquest';

import { IAjaxProvider } from 'jinqu';

/**
 * PerformanceFormDetailExtraFieldApi - API class
 */
export class PerformanceFormDetailExtraFieldApi extends LinqService {

  /**
   * Creates a new PerformanceFormDetailExtraFieldApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * @param dto
   */
  addOrUpdateAsync(dto?: PerformanceFormDetailExtraFieldDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormDetailExtraField/AddOrUpdateAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormDetailExtraField/DeleteAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormDetailExtraField/GetAsync`;
    let query = this.createQuery<PerformanceFormDetailExtraFieldDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormDetailExtraField/GetTranslatedAsync`;
    let query = this.createQuery<PerformanceFormDetailExtraFieldTranslatedDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormDetailExtraField/List`;
    let query = this.createQuery<PerformanceFormDetailExtraFieldDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormDetailExtraField/ListTranslated`;
    let query = this.createQuery<PerformanceFormDetailExtraFieldTranslatedDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param dto
   */
  saveAsync(dto?: PerformanceFormDetailExtraFieldDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormDetailExtraField/SaveAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param yearParams
   */
  getExtraFieldsByYearParams(yearParams?: YearParameter, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormDetailExtraField/GetExtraFieldsByYearParams`;
    let query = this.createQuery<PerformanceFormDetailExtraFieldTranslatedDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    options.data = yearParams;
    query = query.withOptions(options);

    return query;
  }


  /**
   * @param operationYearId
   */
  getExtraFieldsByOperationYearIdAsync(operationYearId?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormDetailExtraField/GetExtraFieldsByOperationYearIdAsync`
    let query = this.createQuery<ExtraFieldDetails>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'operationYearId', value: operationYearId && operationYearId.toString() })
    query = query.withOptions(options)

    return query
  }



  /**
   * @param request
   */
  bulkAddOrUpdateAsync(request?: PerformanceFormDetailExtraFieldViewModel, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormDetailExtraField/BulkAddOrUpdateAsync`
    let query = this.createQuery<PerformanceFormDetailExtraFieldViewModel>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set body parameter
    options.data = request
    query = query.withOptions(options)

    return query.firstAsync()
  }


  /**
   * @param rootId
   */
  deleteBulkAsync(rootId?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormDetailExtraField/DeleteBulkAsync`
    let query = this.createQuery<ExtraFieldDetails>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'rootId', value: rootId && rootId.toString() })
    query = query.withOptions(options)

    return query
  }
}
